import type {
  EmployeeAssignment,
  CreateAssignmentRequest,
  UpdateAssignmentRequest,
} from '@pay-plan/shared';
import { apiRequest } from './client.js';

export async function listAssignments(locationId: string): Promise<EmployeeAssignment[]> {
  const res = await apiRequest<{ assignments: EmployeeAssignment[] }>(
    'GET',
    `/locations/${encodeURIComponent(locationId)}/assignments`,
  );
  return res.assignments;
}

export async function listEmployeeAssignments(
  locationId: string,
  employeeId: string,
): Promise<EmployeeAssignment[]> {
  const res = await apiRequest<{ assignments: EmployeeAssignment[] }>(
    'GET',
    `/locations/${encodeURIComponent(locationId)}/employees/${encodeURIComponent(employeeId)}/assignments`,
  );
  return res.assignments;
}

export async function countTemplateAssignments(
  locationId: string,
  templateId: string,
): Promise<number> {
  const res = await apiRequest<{ count: number }>(
    'GET',
    `/locations/${encodeURIComponent(locationId)}/templates/${encodeURIComponent(templateId)}/assignment-count`,
  );
  return res.count;
}

export async function createAssignment(
  locationId: string,
  data: CreateAssignmentRequest,
): Promise<EmployeeAssignment> {
  const res = await apiRequest<{ assignment: EmployeeAssignment }>(
    'POST',
    `/locations/${encodeURIComponent(locationId)}/assignments`,
    data,
  );
  return res.assignment;
}

export async function updateAssignment(
  locationId: string,
  assignmentId: string,
  data: UpdateAssignmentRequest,
): Promise<EmployeeAssignment> {
  const res = await apiRequest<{ assignment: EmployeeAssignment }>(
    'PATCH',
    `/locations/${encodeURIComponent(locationId)}/assignments/${encodeURIComponent(assignmentId)}`,
    data,
  );
  return res.assignment;
}

export async function deleteAssignment(
  locationId: string,
  employeeId: string,
  assignmentId: string,
  cascade = false,
): Promise<{ paySheetsCascaded: number }> {
  const path = `/locations/${encodeURIComponent(locationId)}/employees/${encodeURIComponent(employeeId)}/assignments/${encodeURIComponent(assignmentId)}${cascade ? '?cascade=true' : ''}`;
  const res = await apiRequest<{ deleted: boolean; paySheetsCascaded?: number }>('DELETE', path);
  return { paySheetsCascaded: res.paySheetsCascaded ?? 0 };
}
